import { Component, EventEmitter, Input, OnInit, Output, OnChanges, SimpleChanges } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';

@Component({
    selector: 'auto-advanced-lead-management',
    templateUrl: './lead-management.component.html',
    styleUrls: ['./lead-management.component.scss'],
    standalone: false
})
export class AdvancedLeadManagementComponent implements OnInit, OnChanges {
  @Input() data: any | null = null;
  @Output() dataEmitter = new EventEmitter<UntypedFormGroup>();
  form: UntypedFormGroup;

  constructor(private formBuilder: UntypedFormBuilder) {}

  ngOnInit(): void {
    this.form = this.formBuilder.group({
      leadFormConsentEnabled: [false],
      leadFormConsentText: [''],
      detailedLeadFormConsentEnabled: [false],
      detailedLeadFormConsentText: [''],
      leadsNeedPostalCode: [false],
      preferredContactRequired: [true],
      newFormMainCtaText: [''],
      usedFormMainCtaText: [''],
      leadSourceAddonText: [''],
      customerChoosesLocation: [false],
      enableDdcCodes: [false]
    });

    this.dataEmitter.emit(this.form);
    this.patchFromInput(this.data);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['data']) {
      this.patchFromInput(changes['data'].currentValue);
    }
  }

  private patchFromInput(leadMgmtAdvancedSettings: any): void {
    const hasFormAndInput = !!leadMgmtAdvancedSettings && !!this.form;

    if (hasFormAndInput) {
      this.form.patchValue({
        leadFormConsentEnabled: !!leadMgmtAdvancedSettings.ccpaConsentEnabled,
        leadFormConsentText: leadMgmtAdvancedSettings.ccpaConsentText || '',
        detailedLeadFormConsentEnabled: !!leadMgmtAdvancedSettings.tcpaConsentEnabled,
        detailedLeadFormConsentText: leadMgmtAdvancedSettings.tcpaConsentText || '',
        leadsNeedPostalCode: !!leadMgmtAdvancedSettings.requirePostalCodeOnLeadForms,
        preferredContactRequired: !!leadMgmtAdvancedSettings.requirePreferredContactOnLeadForm,
        newFormMainCtaText: leadMgmtAdvancedSettings.newFormMainCtaText || '',
        usedFormMainCtaText: leadMgmtAdvancedSettings.usedFormMainCtaText || '',
      }, {emitEvent: false});

      this.form.markAsPristine();
    }
  }
}
